import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InspectionPhoto, RecommendationParams, SaveRecommendationPhotoParams } from '../report-builder-models';
import { ReportBuilderService } from '../report-builder.service';
import { MatDialog } from '@angular/material/dialog';import { AddPhotoModalComponent } from '../add-photo-modal/add-photo-modal.component';

@Component({
    selector: 'recommended-action',
    templateUrl: './recommended-action.component.html',
    styleUrls: ['./recommended-action.component.scss']
})
export class RecommendedActionComponent implements OnInit {
    displayToggleButton: boolean = false;

    @Input() inspectionID: number = 0;
    @Input() rcmAction: RecommendationParams;
    @Output() recommendationUpdated: EventEmitter<RecommendationParams> = new EventEmitter();
    @Output() recommendationDeleted: EventEmitter<RecommendationParams> = new EventEmitter();

    _Photos: InspectionPhoto[] = [];
    _Placeholder: string = 'Enter a recommendation';

    RS_EQUIPMENT_PHOTOS_ONLY: number = 1;
    RS_ALL_INSPECTION_PHOTOS: number = 2;

    constructor(private _rbService: ReportBuilderService, public addPhotoModalComponent: MatDialog) { }

    ngOnInit() {
        this.getImages();
    }

    saveValue() {
        this.recommendationUpdated.emit(this.rcmAction);
    }

    saveText(newValue: string) {
        this.rcmAction.RecommendationText = newValue;
        this.saveValue();
    }


    deleteRecommendation() {
        this.recommendationDeleted.emit(this.rcmAction);
    }

    onMouseOver() {
        this.displayToggleButton = true;
    }

    onMouseOut() {
        this.displayToggleButton = false;
    }

    deleteImage(img: number) {
        this._rbService.DeleteRecommendationPhoto(img).subscribe(res => {
            if (res != null) {
                console.log("Removed recommendation image.");
                this.getImages();
            }
        });
    }

    getImages() {
        this._rbService.GetRecommendationPhotos(this.rcmAction.RecommendationId).subscribe(res => {
            if (res != null) {
                this._Photos = [];
                this._Photos = this._Photos.concat(res);
            }
        });
    }

    addImage() {
        let addPhotoModalRef = this.addPhotoModalComponent.open(AddPhotoModalComponent, {
            width: '780px',
            height: '720px',
            data: {
                inspectionID: this.inspectionID,
                photoType: this.RS_ALL_INSPECTION_PHOTOS
            }
        });
        addPhotoModalRef.afterClosed().subscribe(res => {
            if (res != null) {
                this.addRecommendationPhotoToReport(res.data.id, res.data.photoType);
            }
        });
    }

    addRecommendationPhotoToReport(id: number, photoType: number) {

        var params: SaveRecommendationPhotoParams = new SaveRecommendationPhotoParams();
        params.recommendationId = this.rcmAction.RecommendationId;
        params.photoId = id;
        params.photoType = photoType;

        // Save any new recommendation entries first, before adding the image.
        if (this.rcmAction.RecommendationId == 0) {
            this._rbService.SaveRecommendation(this.rcmAction).subscribe(res => {
                if (res > 0) {
                    this.rcmAction.RecommendationId = res;
                    params.recommendationId = res;

                    // Now proceed with adding the image.
                    this._rbService.SaveRecommendationPhoto(params).subscribe(res => {
                        if (res != null) {
                            this.getImages();
                        }
                    });
                }
            });
        }
        // Recommendation already exists, so add the image.
        else {
            this._rbService.SaveRecommendationPhoto(params).subscribe(res => {
                if (res != null) {
                    this.getImages();
                }
            });
        }
    }

    toggleRecommendationImageResize(isLarge: boolean, recommendationImageCategoryId: number) {
        this._rbService.ToggleRecommendationImageResize(isLarge, recommendationImageCategoryId).subscribe(res => {
            if (res != null) {
                //console.log(res);
            }
        });
    }
}
